export default "__VITE_ASSET__DyDYt52R__"